import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  padding: 0 40px;
`;

export default Container;
